import SimpleLightbox from "simplelightbox";

new SimpleLightbox('.simplelightbox a', { /* options */ }); /* https://simplelightbox.com/ */